import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

@Injectable()
export class PortAggregateService extends ApiService {
  constructor(private http: Http) {
    super('api/ports-report/', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/port-aggregate.service.ts